module.exports = __webpack_public_path__ + "img/back2.5b4a1161.png";